<template>
    <Modal title="取消备注" v-model="show" :closable="false" :mask-closable="false">
        <div solt="header">
            <div style="text-align: center;color: #f00"> 取消之后，手续费将返回给客户</div>
        </div>
        <el-form ref="back" label-position="right" label-width="80px" :model="back" :rules="backRules">
           
            <el-form-item label="备注" prop="remark">
                <el-input type="textarea" v-model="back.remark" placeholder="备注" style="width: 240px" />
            </el-form-item>
        </el-form>
        
        <div slot="footer">
            <el-button size="small" @click="cancel">取消</el-button>
            <el-button size="small" type="primary" :loading="loading" @click="ok">确定</el-button>
        </div>
    </Modal>
</template>
<script>
export default {
    name: "",
    data() {
        return {
            loading: false,
            back: {
                remark: ""
            },
            backRules: {
                remark: [
                    { required: true, Message: "备注不能为空" }
                ]
            }
        }
    },
    props: [
        'waybillId', 'show'
    ],
    methods: {


        ok: function() {
            var ok = false;
            this.$refs['back'].validate((valid) => {
                ok = valid;
                if (valid) {

                } else {
                    this.$Message.error('请认真填写数据');
                }
            });
            if (!ok) return;
            var me = this;
            me.loading = true;
            me.$http.post("/ware/waybill/back.action", { waybillId: me.waybillId, remark: me.back.remark }).then(response => {
                var body = response;
                me.loading = false;
                if (body.status == 0) {

                    me.remark = "";
                    me.$emit('ok');
                }
                else{
                    me.errorMessage(body.info);
                }

            }, response => {
                me.loading = false;
            });

        },
        cancel: function() {
            this.remark="";
            this.$emit('cancel');
        }

    }
}
</script>
<style scoped>
</style>